export enum PointsExpiryUnits {
  DAY = 'day',
  MONTH = 'month'
}

export enum AppTypes {
  coreLoyalty = 'coreLoyalty',
  coreTeams = 'coreTeams',
  POS = 'POS',
  fisico = 'fisico'
}

export enum AppPrograms {
  points = 'points',
  cashback = 'cashback',
}
